<h3-disable-with-tooltip-helper
  [disable]="disable"
  [style.width]="blockStyle && '100%'"
>
  <button
    type="button"
    class="btn btn-{{ type || 'default' }}"
    [class.btn-block]="blockStyle"
    [h3ClickNSpin]="onClickNSpin"
    [ngClass]="extraClasses"
    [disabled]="disable"
    [tabindex]="tabIndex"
    [matTooltip]="h3Tooltip"
    [matTooltipDisabled]="!h3Tooltip"
  >
    <ng-content></ng-content>
  </button>
</h3-disable-with-tooltip-helper>
